import styled from "styled-components";

const Title = styled.h1`
font-size: 2rem;
  color: ${({ theme }) => theme.text};
  text-align: center;
`

export default Title;